"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ChevronIcon = function (_a) {
    var secondary = _a.secondary;
    return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 12 12" },
        react_1.default.createElement("g", { fill: "none" },
            react_1.default.createElement("path", { fill: secondary ? '#949899' : 'black', d: "M1.5 4.75L2.25 4 6 7.777 9.75 4l.75.75L6 9.25z" }))));
};
exports.default = ChevronIcon;
